module.exports = __webpack_public_path__ + "static/img/8_yaozhui_2.d658175.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product/8_yaozhui_2.gif
// module id = uM6K
// module chunks = 0